import React, { useEffect } from "react";

import Conoce from "../molecules/Conoce";

import top from "../../images/planes/top-nuestros-planes.png";
import funnyOldies from "../../images/planes/header-planes.jpg";
import mobile from "../../images/planes/mobile-planes.png";

// import web from "../../images/plataforma/desktop-home-1.png";
// import smartwatch from "../../images/plataforma/sw-home.png";

import "./NuestrosPlanes.css";
import Planes from "../molecules/Planes";
import EllieTips from "../molecules/EllieTips";
import Funcionalidades2 from "../molecules/FuncionalidadesBig";
import Contacto from "../molecules/Contacto";

export const NuestrosPlanes = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <img
        src={funnyOldies}
        alt="Funny Oldies"
        style={{ width: "100%", margin: "0 auto" }}
      />

      <div id="nuestros-planes">
        <div className="nuestros-planes-container">
          <img
            className="nuestros-planes-image-top"
            src={top}
            alt="Top Porpósito"
          />
        </div>

        <div className="nuestros-planes-container">
          <div className="nuestros-planes-box">
            <h1>Nuestros Planes</h1>
            <p>
              <strong>Tenemos planes que se ajustan a lo que necesitás.</strong>
            </p>
            <p>
              Con cualquiera de nuestros planes vas a estar igual de cuidado,
              tanto por tu <b>Red de Ayuda</b> como por nuestro{" "}
              <b>Ellie Center</b>, disponible todos los días, las{" "}
              <b>24 horas</b>.
            </p>
          </div>
          <div
            className="nuestros-planes-box-image"
            style={{ display: "flex" }}
          >
            <img
              className="nuestros-planes-image"
              src={mobile}
              alt="Mobile Planes"
              style={{ marginBottom: "50px" }}
            />
          </div>
        </div>

        <Planes />
        <EllieTips />
        <Funcionalidades2 />
        <Conoce />
        <section id="contact">
          <Contacto />
        </section>
      </div>
    </>
  );
};

export default NuestrosPlanes;
